// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1e1P0","selects":"Documents_selects__2ec28"};